import { Component, Input, Inject, DOCUMENT } from '@angular/core';
import { LICENSE_PRODUCT_SEAT_TYPES } from 'go-modules/services/group/product';
import { NgxPurchaseTypeService } from '@go-modules/services/purchase-type/purchase-type.service';
import type { Product } from 'go-modules/services/group/product';
import type { cardPaymentMethodPayload } from 'braintree-web-drop-in';
import type { Transaction } from 'go-modules/braintree/braintree.service';
import type { LicenseDetailsForm } from '@go-modules/interfaces/licenses/license-details-form';
import type { Group } from '@go-modules/interfaces/groups/group.interface';

import { GoPrintService } from '@go-modules/services/go-print/go-print.service';

@Component({
	selector: 'payment-complete',
	templateUrl: 'payment-complete.component.html',
	styleUrls: ['./payment-complete.component.scss'],
	standalone: false
})
export class PaymentCompleteComponent {
	@Input() public paymentMethod: cardPaymentMethodPayload;
	@Input() public product: Product;
	@Input() public transaction: Transaction;
	@Input() public group: Group;
	@Input() public options: any;
	@Input() public licenseDetails: LicenseDetailsForm;

	constructor (
		public ngxPurchaseTypeService: NgxPurchaseTypeService,
		private goPrintService: GoPrintService,
		@Inject(DOCUMENT) private document: Document
	) {
	}

	public get licenseTypeTranslationKey (): string {
		return this.licenseDetails.selectedProduct.licenseProduct.seat_type === LICENSE_PRODUCT_SEAT_TYPES.USER ?
			'payment-panel-license-details_license-type-multi-course' :
			'payment-panel-license-details_license-type-single-course';
	}

	public printOrderDetails () {
		this.goPrintService.print(
			this.document.querySelector('.order-details-body'),
			'Order Details:'
		);
	}

	public parseTotal (total: string): number {
		return parseFloat(total.replace(/,/g, ''));
	}
}
